import React from 'react';

import Supervisor from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Colgate/Supervisor/List.js';

export default function () {
  return <Supervisor />;
}
